<div class="action-buttons">
  @if (canAdd) {
    <lib-button class="action-button" variant="icon" icon="add" color="primary" tooltip="Add next step" (buttonClick)="onAddStep()"></lib-button>
  }
  @if (canEdit) {
    <lib-button class="action-button" variant="icon" icon="edit" color="primary" tooltip="Edit step" (buttonClick)="onEditStep()"></lib-button>
  }
  @if (canDelete) {
    <lib-button class="action-button" variant="icon" icon="delete" color="primary" tooltip="Delete step" (buttonClick)="onDeleteStep()"></lib-button>
  }
</div>
